export enum SafeType {
    HTML = 'HTML',
    Styles = 'styles',
    Script = 'script',
    URL = 'url',
    ResourceUrl = 'resourceUrl'
}
